import React from 'react';

const ErrorCard = ({ message }: { message: string }) => {
  return (
    <div className="flex justify-center items-center h-60">
      <div className="bg-red-100 border border-red-400 text-red-700 px-6 py-4 rounded-lg shadow">
        <p>{message}</p>
      </div>
    </div>
  );
};

export default ErrorCard;
